import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService: React.FC = () => {
  return (
    <div className="w-full bg-white">
      <section className="py-16">
        <div className="layout-container max-w-[800px] mx-auto px-5">
          <nav className="mb-6 text-[12px] font-description text-[#919191]">
            <Link to="/" className="hover:text-[#212121] transition-colors">
              Homepage
            </Link>
            <span className="mx-2">/</span>
            <span className="text-[#212121]">Terms of Service</span>
          </nav>

          <h1 className="font-title text-[36px] md:text-[46px] font-semibold leading-[1.1] text-[#212121]">
            Terms of Service
          </h1>
          
          <div className="mt-8 space-y-6 font-description text-[14px] font-light leading-[1.6] text-[#919191]">
            <p><strong>Effective Date:</strong> August 5, {new Date().getFullYear()}</p>
            <p><strong>Company:</strong> Bao Technologies (Bao Technologies and Travels SARL)</p>
            <p><strong>Website:</strong> <a href="https://baotechnologies.com" className="text-[#2776EA] hover:underline">https://baotechnologies.com</a></p>

            <h2 className="font-title text-[20px] font-medium text-[#212121] mt-10 mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing or using the Bao Technologies website and services, you agree to be bound by these Terms of Service. If you do not agree, please refrain from using our site.
            </p>

            <h2 className="font-title text-[20px] font-medium text-[#212121] mt-10 mb-4">2. Services</h2>
            <p>
              Bao Technologies provides custom software development, digital platforms, web and mobile development, business process automation, UI/UX design, QA testing, and technology consultancy. All commercial engagements are governed by separate, signed master services agreements or project-specific contracts.
            </p>

            <h2 className="font-title text-[20px] font-medium text-[#212121] mt-10 mb-4">3. Intellectual Property</h2>
            <p>
              All content, design elements, graphics, text, logos, and software code on this website are the intellectual property of Bao Technologies unless otherwise stated. Unauthorized reproduction, distribution, or commercial exploitation is strictly prohibited.
            </p>

            <h2 className="font-title text-[20px] font-medium text-[#212121] mt-10 mb-4">4. Limitation of Liability</h2>
            <p>
              The information and services provided on this website are on an &quot;as is&quot; and &quot;as available&quot; basis. Bao Technologies makes no warranties, expressed or implied, regarding the uninterrupted availability or absolute accuracy of the website content. In no event shall Bao Technologies be liable for any direct, indirect, or consequential damages arising from the use of our site or services.
            </p>

            <h2 className="font-title text-[20px] font-medium text-[#212121] mt-10 mb-4">5. Governing Law</h2>
            <p>
              These terms are governed by and construed in accordance with the laws of the Republic of Cameroon. Any disputes arising in connection with these terms shall be subject to the exclusive jurisdiction of the competent courts in Douala, Cameroon.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;
